import IgoIfo from './IgoIfo'

/**
 * Note: currently there should be only 1 active IFO at a time
 */

const Igo = () => {
  return <IgoIfo />
}

export default Igo
